import { render, staticRenderFns } from "./warm.vue?vue&type=template&id=22b65a50&scoped=true&"
import script from "./warm.vue?vue&type=script&lang=js&"
export * from "./warm.vue?vue&type=script&lang=js&"
import style0 from "./warm.vue?vue&type=style&index=0&id=22b65a50&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b65a50",
  null
  
)

export default component.exports